module.exports = __webpack_public_path__ + "img/291.98eb7049.gif";